export var HistoricEnrollmentStatus;
(function (HistoricEnrollmentStatus) {
    HistoricEnrollmentStatus["COMPLETED"] = "Conclu\u00EDdo";
    HistoricEnrollmentStatus["IN_PROGRESS"] = "Em andamento";
    HistoricEnrollmentStatus["NOT_STARTED"] = "N\u00E3o iniciado";
    HistoricEnrollmentStatus["EXPIRED"] = "Expirado";
})(HistoricEnrollmentStatus || (HistoricEnrollmentStatus = {}));
//# sourceMappingURL=HistoricEnrollmentCard.types.js.map